import React from "react";
import "./Headers.css";
import { useSelector, useDispatch } from "react-redux";

const Headers = () => {
  const Dispatch = useDispatch();
  const Selector = useSelector((store) => store.userPort.loading);

  return (
    <div>
      <nav class="navbar navbar-expand-lg  navbar-dark   color ">
        <div class="container-fluid">
          <a class="navbar-brand" href="/">
            <strong> Portfolio of Jaime Orlando Urrego L </strong>
          </a>

          <div className="d-flex">
            <ul className="m-2 text-center">
             
              {Selector ? (
                <a class="navbar-brand" href="/admon">
                  <strong> Admon </strong>
                </a>
              ) : (
                <a class="navbar-brand" href="/login">
                  <strong>  </strong>
                </a>
              )}
            </ul>

            <ul className="m-2 text-center">
              {Selector ? (
                <div>
                  <label>
                    {" "}
                    <strong> Usuario : </strong>{" "}
                  </label>

                  <label> Jaime urrego </label>
                </div>
              ) : (
                <a class="navbar-brand" href="/admon">
                  <strong> </strong>
                </a>
              )}

              {Selector ? (
                <div>
                  <button className="btn btn-close-white">
                    {" "}
                    Cerrar seccion{" "}
                  </button>
                </div>
              ) : (
                <p type="text" className=" ">
                  {" "}
                </p>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Headers;
